import React from 'react';
import { connect } from 'react-redux';
import SettingsModal from 'components/SettingsModal/SettingsModal';
import { nucleusConstants } from '@lifesize/nucleus';
import { AV_TAB, PROFILE_TAB, INTEGRATIONS_TAB, NETWORK_TAB } from 'constants/SettingsModal';
import { createSelector } from 'reselect';
import UserSettings from 'containers/SettingsModal/UserSettingsContainer';
import ProfileSettings from 'containers/SettingsModal/ProfileSettingsContainer';
import AdvancedSettings from 'containers/AdvancedSettings/AdvancedSettingsContainer';
import _get from 'lodash/get';
import IntegrationSettings from 'components/SettingsModal/IntegrationSettings';

const visibleTab = (state) => _get(state, 'app.settingsModal.visibleTab');

const getSubComponent = createSelector(visibleTab, (selectedComponent) => {
  switch (selectedComponent) {
    case AV_TAB:
      return <UserSettings />;
    case INTEGRATIONS_TAB:
      return <IntegrationSettings />;
    case NETWORK_TAB:
      return <AdvancedSettings />;
    case PROFILE_TAB:
      return <ProfileSettings />;
    default:
      return null;
  }
});

const mapStateToProps = (state) => ({
  children: getSubComponent(state),
  version: process.env.REACT_APP_VERSION,
  passwordLink: _get(state, 'nucleus.provisioning.changePasswordURL'),
  isSSO: _get(state, 'nucleus.sso.loginSupportType') === nucleusConstants.LOGIN_SUPPORT_TYPE_SSO
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SettingsModal);
